import React from "react";

import {
    Typography,
    Button,
    List,
    ListItem,
    ListItemText,
    TextField,
} from "@material-ui/core";

import { Modal, ModalHeader, ModalFooter, ModalBody } from "reactstrap";

export class UploaderModal extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            files: [],
            duplicates: {},
        };
    }
    isDuplicate(newFiles, currFiles) {
        if (currFiles && newFiles && newFiles.length !== 0) {
            let currNames = Object.keys(currFiles).map(
                (e) => currFiles[e].file_name
            );
            let newNames = Object.keys(newFiles).map((e) => {
                return { name: newFiles[e].name, uid: e };
            });
            let duplicateIDs = {};
            newNames.map((e) => {
                if (currNames.includes(e.name))
                    duplicateIDs = { ...duplicateIDs, [e.uid]: e.name };
                return null;
            });
            return Object.keys(duplicateIDs).length <= 0 ? {} : duplicateIDs;
        } else {
            return {};
        }
    }
    isSubmitDisabled(names, dups) {
        let flag = false;
        Object.keys(dups).map((e) => {
            if (names.includes(dups[e])) flag = true;
            return null;
        });
        return flag;
    }
    render() {
        const {
            uploadFile,
            activeFolder,
            inProgress,
            success,
            error,
            closeModal,
            uploadFileModal,
            maxSize,
            fileExists,
            allFiles = false,
        } = this.props;
        const { files = [], duplicates = {} } = this.state;

        let folderFiles = allFiles ? allFiles[activeFolder] : false;
        const currNames = folderFiles
            ? Object.keys(folderFiles).map((e) => folderFiles[e].file_name)
            : [];
        return (
            <Modal isOpen={uploadFileModal}>
                <ModalHeader>Upload File</ModalHeader>
                <ModalBody>
                    <ModalInfoText
                        text={`Upload your files into ${activeFolder.replace(
                            "_",
                            " "
                        )}`}
                    />

                    <React.Fragment>
                        <input
                            accept="application/msword, application/vnd.ms-excel, application/vnd.ms-powerpoint,
                                text/plain, application/pdf, image/*"
                            type="file"
                            multiple
                            onChange={(event) => {
                                let dups = this.isDuplicate(
                                    event.target.files,
                                    folderFiles
                                );
                                this.setState({
                                    files: event.target.files,
                                    duplicates: dups,
                                });
                            }}
                            style={{
                                display: "none",
                            }}
                            ref={(fileInput) => (this.fileInput = fileInput)}
                        />

                        <Button
                            color="primary"
                            style={{
                                width: "auto",
                                display: "inline",
                            }}
                            onClick={() => {
                                this.fileInput.click();
                            }}
                            variant="contained"
                        >
                            Select File(s)
                        </Button>
                    </React.Fragment>

                    <List>
                        {files &&
                            Object.keys(files).map((id) => {
                                return (
                                    <ListItem
                                        style={{
                                            border: duplicates[id]
                                                ? "2px solid red"
                                                : "2px solid green",
                                            margin: 4,
                                            borderRadius: 8,
                                        }}
                                    >
                                        {!duplicates[id] ? (
                                            <ListItemText
                                                primary={files[id].name}
                                            />
                                        ) : (
                                            <>
                                                <TextField
                                                    error={true}
                                                    value={duplicates[id]}
                                                    fullWidth
                                                    label={
                                                        "Name Duplication. Please rename file before uploading"
                                                    }
                                                    onChange={(ev) => {
                                                        let dups = duplicates;
                                                        dups[id] =
                                                            ev.target.value;
                                                        this.setState({
                                                            duplicates: dups,
                                                        });
                                                    }}
                                                />
                                            </>
                                        )}
                                    </ListItem>
                                );
                            })}
                    </List>
                </ModalBody>
                <ModalFooter>
                    <Button
                        onClick={() => {
                            closeModal();
                            this.setState({
                                files: [],
                                duplicates: {},
                            });
                        }}
                        variant="contained"
                    >
                        Cancel
                    </Button>
                    <Button
                        style={{
                            background: this.isSubmitDisabled(
                                currNames,
                                duplicates
                            )
                                ? "lightgrey"
                                : "#0188cc",
                            color: "white",
                        }}
                        disabled={this.isSubmitDisabled(currNames, duplicates)}
                        onClick={() => {
                            Object.keys(files).map((index) => {
                                if (files[index].size < 10000000)
                                    uploadFile(
                                        activeFolder,
                                        index,
                                        files[index],
                                        (status) => {
                                            if (status.inProgress) {
                                                inProgress(status.progress);
                                            } else if (status.finished) {
                                                success(false, true, false);
                                            } else if (status.error) {
                                                error(true);
                                            } else if (status.fileExists) {
                                                fileExists(true);
                                            }
                                        },
                                        duplicates
                                    );
                                else maxSize(true);
                                return null;
                            });
                            this.setState({
                                files: [],
                                duplicates: {},
                            });
                            closeModal();
                        }}
                        variant="contained"
                    >
                        Upload
                    </Button>
                </ModalFooter>
            </Modal>
        );
    }
}
const ModalInfoText = (props) => {
    return (
        <Typography variant="subheading" style={{ marginBottom: 15 }}>
            {props.text}
        </Typography>
    );
};
